import axios from 'axios'
import store from '../store'
import router from '../router'

export default function axiosInterceptors () {
	axios.interceptors.request.use((config) => {
		const token = store.getters.token
		if (token) {
			config.headers.Authorization = token
		}
		return config
	}, (err) => {
		return Promise.reject(err)
	})

	axios.interceptors.response.use((response) => {
		// Do something with response data
		if (response.data.code === '401') {
			store.commit('logout')
			router.push({ name: 'Login' })
		}
		return response
	}, (error) => {
		// Do something with response error
		return Promise.reject(error)
	})
}



// WEBPACK FOOTER //
// ./src/helpers/interceptors.js